














































import { Component, Provide, ProvideReactive, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import userModel from '@/store/modules/user';
import SessionModule from '@/store/modules/session';
import { Dialog } from 'vant';
import LocalForm from './localForm2.vue';
import NetworkForm from './NetworkForm.vue';
import { getUrlParam } from '@/utils/util';
import UserModule from '@/store/modules/user';

@Component({ components: { LocalForm, NetworkForm } })
export default class LoginComponent extends Vue {
  isDispaly: boolean = false;
  isHaveNetworkAccount: boolean = true;
  authKey: string = '';
  classId: string = '';
  opreateType: string = '';
  classType: string = '';
  @ProvideReactive() wxOpenId = '';
  @ProvideReactive() Signature = '';

  localRegister(data) {
    this.getInfo(data);
  }

  networkSuccess(data) {
    this.getInfo(data);
  }

  mounted() {
    UserModule.LogOut();
    this.authKey = getUrlParam('authKey').replace('#/', '');
    this.classId = getUrlParam('classId');
    this.opreateType = getUrlParam('opreateType');
    this.classType = getUrlParam('classType');

    // if (process.env.NODE_ENV === 'production') {
    if (this.authKey.length < 1) {
      this.getAuthUrl();
    } else {
      this.automaticLogon();
    }
    // }
  }

  async getInfo(data: any) {
    const time = new Date(new Date().getTime() + data.data.expires_in * 1000);
    await userModel.SetData({
      refresh_token: '',
      expires_time: time,
      token: data.data.access_token,
    });
    await userModel.SetUserInfo(data);
    SessionModule.ACTIVE_USER({
      userId: data.data.userId,
      deptName: data.data.deptName,
      userName: data.data.phone,
      name: data.data.name,
      token: data.data.access_token,
      refresh_token: '',
      expires_time: time,
      userType: data.data.userType,
      openId: data.openId,
    });
    //const to = this.$route.query.redirect && this.$route.query.redirect !== '/404' ? this.$route.query.redirect : '/home';

    this.$router.push({
      name: 'home',
      query: {
        classId: this.classId,
        opreateType: this.opreateType,
        classType: this.classType,
      },
    });
  }

  async automaticLogon() {
    try {
      const result: any = await api.AccountApp.autoLoginByAuthkey_POST({ authKey: this.authKey });
      if (result.success) {
        this.Signature = result.data.signature;
        this.wxOpenId = result.data.openId;
        if (result.data.success) {
          const data: any = result?.data;
          this.getInfo(data);
        } else {
          Dialog.alert({
            message: result.data.message,
            title: '错误提示',
          });
        }
      }
    } catch (error) {
      Dialog.alert({
        title: '错误',
        message: error.toString(),
      });
    }
  }

  async getAuthUrl() {
    const result = await api.AccountApp.getAuthUrl_GET({
      classId: this.classId,
      opreateType: this.opreateType,
      classType: this.classType,
    });
    const url = result.data as string;
    if (url != null) {
      location.href = url + '&timestamp=' + new Date().getTime() + Math.random();
    } else {
      Dialog.alert({
        message: '未获取到授权结果跳转Url',
        title: '提示',
      });
    }
  }

  changeHaveNetworkAccount(value: boolean) {
    this.isHaveNetworkAccount = value;
  }

  async localLogin(phone: string, token: string) {
    if (token.length < 1) {
      Dialog.alert({
        message: 'token不能为空。',
        title: '提示',
      });
      return;
    }
    if (phone.length < 1) {
      Dialog.alert({
        message: '手机号不能为空。',
        title: '提示',
      });
      return;
    }
    const result = await api.AccountApp.login_POST({ Phone: phone, Accesstoken: token });
    if (result.success) {
      const data = result.data;
      data['username'] = phone;
      const time = new Date(new Date().getTime() + data.expires_in * 1000);
      await userModel.SetData({
        refresh_token: '',
        expires_time: time,
        token: data.access_token,
      });
      await userModel.SetUserInfo(data);
      SessionModule.ACTIVE_USER({
        userId: data.userId,
        deptName: data.deptName,
        userName: phone,
        name: data.name,
        token: data.access_token,
        refresh_token: '',
        expires_time: time,
        userType: data.userType,
      });
      //const to = this.$route.query.redirect && this.$route.query.redirect !== '/404' ? this.$route.query.redirect : '/home';

      this.$router.push({
        name: 'home',
        query: {
          classId: this.classId,
          opreateType: this.opreateType,
          classType: this.classType,
        },
      });
    } else {
      Dialog.alert({
        message: result.message,
        title: '提示',
      });
    }
  }

  beforeCreate() {}
}
